import {
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import React from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import { Route, Switch } from 'react-router'
import BackgroundPage from 'src/components/BackgroundPage/BackgroundPage'
import NotFoundBackgroundPageContent from 'src/components/NotFoundBackgroundPageContent/NotFoundBackgroundPageContent'
import TitleHeader from 'src/components/TitleHeader/TitleHeader'
import Topnav from 'src/components/Topnav/Topnav'
import Trns from 'src/localization/Trns'
import ProfileAppRoute from 'src/navigation/appRoutes/profile.appRoute'
import { Rdrct } from 'src/navigation/Lnk'
import { profileOverviewUrl } from 'src/navigation/urls'
import { selectCalculatedBackgroundLocation } from 'src/redux/selectors/router.selectors'
import { selectAppName } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

const Profile: React.FC = () => {
  const calculatedBackgroundLocation = useSelector(
    selectCalculatedBackgroundLocation,
  )
  const appName = useSelector(selectAppName)

  return (
    <BackgroundPage>
      <Helmet>
        <title>{`Profile Settings | ${appName}`}</title>
        <meta
          name="description"
          content={`Profile Settings page of ${appName}`}
        />
      </Helmet>
      <Topnav
        titleElements={{
          scrollContent: (
            <span
              css={css`
                ${getFontCss(
                  14,
                  themeConstants.colors.font_primary,
                  styleConstants.fontFamilies.medium,
                )};
              `}
            >
              <Trns source={'Profile Settings'} />
            </span>
          ),
        }}
      />
      <TitleHeader title={<Trns source={'Profile Settings'} />} />
      <Switch location={calculatedBackgroundLocation}>
        {ProfileAppRoute.subRoutes.map((route, i) => (
          <Route key={i} {...route.routeProps}>
            {route.component}
          </Route>
        ))}
        <Route {...ProfileAppRoute.routeProps} exact>
          <Rdrct to={profileOverviewUrl()} />
        </Route>
        <Route path={'/'}>
          <NotFoundBackgroundPageContent />
        </Route>
      </Switch>
    </BackgroundPage>
  )
}

export default Profile
